import * as Yup from 'yup';

import { Nullable } from '~globals/types';
import { RouteCalculationModeType } from '~globals/types/enums';
import { VALIDATIONS_ERROR } from '~constants/index';
import { PointAddressSelectorOptionValue } from '~components/PointAddressSelector/types';

export const DEFAULT_ORIGIN_ID = '04FF3627-8F0A-44F8-8EB1-03F44F9385F1';
export const DEFAULT_DESTINY_ID = 'E484A798-F9EE-4F4F-A788-C0ABE6DAEE4D';

export const FIELDS_NAME = {
  NAME: 'name',
  SCHEDULE_DATE: 'scheduleDate',
  STARTING_POINT_TYPE: 'startingPointType',
  STARTING_POINT_ID: 'startingPointId',
  STARTING_POINT_ADDRESS: 'startingPointAddress',
  STARTING_POINT_ADDRESS_COORDS: 'startingPointAddressCoords',
  ARRIVAL_POINT_TYPE: 'arrivalPointType',
  ARRIVAL_POINT_ID: 'arrivalPointId',
  ARRIVAL_POINT_ADDRESS: 'arrivalPointAddress',
  ARRIVAL_POINT_ADDRESS_COORDS: 'arrivalPointAddressCoords',
  CALCULATION_MODE: 'calculationMode',
  LOAD_BALACING_VEHICLES: 'loadingBalancingVehicles',
  MULTIPLE_ROUTES_PER_VEHICLE: 'multipleRoutesPerVehicle',
} as const;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInitialValues = ({ scheduleDate }: { scheduleDate: Date }) => ({
  [FIELDS_NAME.NAME]: '',
  [FIELDS_NAME.SCHEDULE_DATE]: scheduleDate as Date | null,
  [FIELDS_NAME.STARTING_POINT_TYPE]:
    'warehouse' as PointAddressSelectorOptionValue,
  [FIELDS_NAME.STARTING_POINT_ID]: '',
  [FIELDS_NAME.STARTING_POINT_ADDRESS]: '',
  [FIELDS_NAME.STARTING_POINT_ADDRESS_COORDS]:
    null as Nullable<google.maps.LatLngLiteral>,
  [FIELDS_NAME.ARRIVAL_POINT_TYPE]:
    'warehouse' as PointAddressSelectorOptionValue,
  [FIELDS_NAME.ARRIVAL_POINT_ID]: '',
  [FIELDS_NAME.ARRIVAL_POINT_ADDRESS]: '',
  [FIELDS_NAME.ARRIVAL_POINT_ADDRESS_COORDS]:
    null as Nullable<google.maps.LatLngLiteral>,
  [FIELDS_NAME.CALCULATION_MODE]: String(RouteCalculationModeType.Faster),
  [FIELDS_NAME.LOAD_BALACING_VEHICLES]: false,
  [FIELDS_NAME.MULTIPLE_ROUTES_PER_VEHICLE]: false,
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const validationSchema = (isRouteCollect: boolean) =>
  Yup.object().shape({
    [FIELDS_NAME.NAME]: Yup.string().notRequired(),
    [FIELDS_NAME.SCHEDULE_DATE]: Yup.date()
      .nullable()
      .typeError(VALIDATIONS_ERROR.INVALID_DATE)
      .required(VALIDATIONS_ERROR.REQUIRED),
    [FIELDS_NAME.STARTING_POINT_TYPE]: Yup.string().required(
      VALIDATIONS_ERROR.REQUIRED,
    ),
    [FIELDS_NAME.STARTING_POINT_ID]: Yup.string().required(
      VALIDATIONS_ERROR.REQUIRED,
    ),
    [FIELDS_NAME.STARTING_POINT_ADDRESS]: Yup.string().required(
      VALIDATIONS_ERROR.REQUIRED,
    ),
    [FIELDS_NAME.STARTING_POINT_ADDRESS_COORDS]: Yup.mixed().required(
      VALIDATIONS_ERROR.REQUIRED,
    ),
    [FIELDS_NAME.ARRIVAL_POINT_TYPE]: isRouteCollect
      ? Yup.string().required(VALIDATIONS_ERROR.REQUIRED)
      : Yup.string().notRequired(),
    [FIELDS_NAME.ARRIVAL_POINT_ID]: isRouteCollect
      ? Yup.string().required(VALIDATIONS_ERROR.REQUIRED)
      : Yup.string().notRequired(),
    [FIELDS_NAME.ARRIVAL_POINT_ADDRESS]: isRouteCollect
      ? Yup.string().required(VALIDATIONS_ERROR.REQUIRED)
      : Yup.string().notRequired(),
    [FIELDS_NAME.ARRIVAL_POINT_ADDRESS_COORDS]: isRouteCollect
      ? Yup.mixed().required(VALIDATIONS_ERROR.REQUIRED)
      : Yup.mixed().notRequired(),
    [FIELDS_NAME.CALCULATION_MODE]: Yup.string().required(
      VALIDATIONS_ERROR.REQUIRED,
    ),
    [FIELDS_NAME.LOAD_BALACING_VEHICLES]: Yup.boolean(),
    [FIELDS_NAME.MULTIPLE_ROUTES_PER_VEHICLE]: Yup.boolean(),
  });
